export const NoPointers = Object.freeze({ mandatory: false, accepts: [] });
